import api from './services/mkm.api.js'

const resource = '/veranstaltung'

export default {
    alle() {
        return api.get(`${resource}`)
    },
    byKey(key) {
        return api.get(`${resource}/${key}`);
    },
    faecher(key) {
        return api.get(`${resource}/${key}/faecher`);
    },
    senden(payload) {
        return api.post(`${resource}/anmeldung`, payload)
    },
    teilnahmeErstellen(teilnahme) {
        return api.post(`${resource}/teilnahme`, teilnahme);
    }
}